import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.tanzcentrum-ettlingen.de',
  withCredentials: true
});

export default apiClient;
